import { Tooltip } from '@project44/entity-ui-utils';
import { Box, CSS, Typography } from '@project44/manifest-ds';

import { getDateDiff } from '../../../utils/functions/getDateDiff';

interface DateDiffProps {
  css?: CSS;
  predictedDate?: string;
  plannedEndDate?: string;
  plannedStartDate?: string;
  timeZone?: string;
}

export const DateDiff = ({
  css,
  predictedDate,
  plannedEndDate,
  plannedStartDate,
}: DateDiffProps) => {
  const differenceMsg =
    predictedDate && plannedStartDate
      ? getDateDiff(predictedDate, plannedStartDate, plannedEndDate)
      : undefined;

  if (plannedStartDate && !predictedDate)
    return (
      <Typography variant="subtext" data-testid="date-diff-empty" css={css}>
        -
      </Typography>
    );

  if (!differenceMsg) {
    return null;
  }
  return (
    <Tooltip message={differenceMsg.tooltip} data-testid="date-diff-tooltip">
      <Box
        data-testid="date-diff"
        as="span"
        css={{
          fontWeight: '$semibold',
          marginLeft: '6px',
          color: differenceMsg.color,
        }}
      >
        {differenceMsg.text}
      </Box>
    </Tooltip>
  );
};

export default DateDiff;
